var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 481,
    viewBox: "0 0 1440 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_361_109839",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -20,
    y: 52,
    width: 1460,
    height: 354
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 52.8867H-20V405.887H1440V52.8867Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_361_109839)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-28.041 477.851C792.321 371.732 1126.93 62.239 1434.35 371.888",
    stroke: "url(#paint0_linear_361_109839)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.6582 467.224C787.088 360.046 1118.02 74.4047 1433.57 367.171",
    stroke: "url(#paint1_linear_361_109839)",
    strokeWidth: 2.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.1309 456.583C781.871 348.318 1109.12 86.606 1432.73 362.433",
    stroke: "url(#paint2_linear_361_109839)",
    strokeWidth: 2.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32.7305 445.956C776.637 336.604 1100.21 98.7786 1431.93 357.716",
    stroke: "url(#paint3_linear_361_109839)",
    strokeWidth: 2.71,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.3105 435.337C771.404 324.883 1091.29 110.959 1431.11 353.014",
    stroke: "url(#paint4_linear_361_109839)",
    strokeWidth: 2.61,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35.7656 424.689C766.169 313.127 1082.37 123.146 1430.24 348.276",
    stroke: "url(#paint5_linear_361_109839)",
    strokeWidth: 2.51,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.3105 414.062C760.935 301.377 1073.46 135.319 1429.4 343.58",
    stroke: "url(#paint6_linear_361_109839)",
    strokeWidth: 2.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.9629 403.45C755.702 289.628 1064.54 147.464 1428.59 338.906",
    stroke: "url(#paint7_linear_361_109839)",
    strokeWidth: 2.31,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.4727 392.823C750.485 277.857 1055.63 159.629 1427.73 334.224",
    stroke: "url(#paint8_linear_361_109839)",
    strokeWidth: 2.21,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41.9805 382.189C745.252 266.073 1046.69 171.789 1426.84 329.543",
    stroke: "url(#paint9_linear_361_109839)",
    strokeWidth: 2.12,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-43.5625 371.57C740.035 254.281 1037.79 183.926 1426.01 324.897",
    stroke: "url(#paint10_linear_361_109839)",
    strokeWidth: 2.02,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45.125 360.951C734.82 242.476 1028.88 196.064 1425.17 320.259",
    stroke: "url(#paint11_linear_361_109839)",
    strokeWidth: 1.92,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.6504 350.331C729.642 230.663 1019.98 208.202 1424.35 315.634",
    stroke: "url(#paint12_linear_361_109839)",
    strokeWidth: 1.82,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.1777 339.704C724.461 218.836 1011.09 220.333 1423.53 311.009",
    stroke: "url(#paint13_linear_361_109839)",
    strokeWidth: 1.72,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.7402 329.084C719.319 206.98 1002.22 232.463 1422.81 306.405",
    stroke: "url(#paint14_linear_361_109839)",
    strokeWidth: 1.62,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-51.2852 318.472C714.212 195.125 993.372 244.615 1422.12 301.808",
    stroke: "url(#paint15_linear_361_109839)",
    strokeWidth: 1.53,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.8848 307.86C709.123 183.235 984.54 256.767 1421.48 297.212",
    stroke: "url(#paint16_linear_361_109839)",
    strokeWidth: 1.43,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-54.3574 297.232C704.088 171.344 975.743 268.939 1420.88 292.607",
    stroke: "url(#paint17_linear_361_109839)",
    strokeWidth: 1.33,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55.9551 286.627C699.074 159.425 966.949 281.148 1420.37 287.99",
    stroke: "url(#paint18_linear_361_109839)",
    strokeWidth: 1.23,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.4648 276.008C694.057 147.506 958.152 293.37 1419.84 283.358",
    stroke: "url(#paint19_linear_361_109839)",
    strokeWidth: 1.13,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58.9902 265.395C689.079 135.567 949.375 305.628 1419.41 278.712",
    stroke: "url(#paint20_linear_361_109839)",
    strokeWidth: 1.04,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-60.5352 254.79C684.117 123.613 940.597 317.929 1419.01 274.038",
    stroke: "url(#paint21_linear_361_109839)",
    strokeWidth: 0.94,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.0977 244.184C679.156 111.63 931.82 330.243 1418.65 269.335",
    stroke: "url(#paint22_linear_361_109839)",
    strokeWidth: 0.84,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-63.6426 233.571C674.176 99.6401 923.024 342.585 1418.25 264.611",
    stroke: "url(#paint23_linear_361_109839)",
    strokeWidth: 0.74,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-65.1328 222.959C669.215 87.6583 914.246 354.942 1417.85 259.874",
    stroke: "url(#paint24_linear_361_109839)",
    strokeWidth: 0.64,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-66.6953 212.361C664.236 75.648 905.433 367.341 1417.47 255.115",
    stroke: "url(#paint25_linear_361_109839)",
    strokeWidth: 0.54,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.2402 201.756C659.238 63.6233 896.618 379.74 1417.08 250.328",
    stroke: "url(#paint26_linear_361_109839)",
    strokeWidth: 0.45,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69.75 191.15C654.257 51.598 887.785 392.152 1416.66 245.533",
    stroke: "url(#paint27_linear_361_109839)",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.2949 180.552C649.241 39.5596 878.934 404.594 1416.25 240.732",
    stroke: "url(#paint28_linear_361_109839)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M476.523 427.139C476.523 427.139 1014.45 228.375 1361.62 338.144",
    stroke: "#C0E7FF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M477.232 429.434C477.232 429.434 1010.95 232.774 1361.62 343.347",
    stroke: "#C0E7FF",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M477.941 431.729C477.941 431.729 1007.44 237.173 1361.6 348.544",
    stroke: "#C0E7FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M478.65 434.024C478.65 434.024 1003.93 241.572 1361.6 353.741",
    stroke: "#C0E7FF",
    strokeWidth: 0.62,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M479.377 436.318C479.377 436.318 1000.42 245.97 1361.62 358.938",
    stroke: "#C0E7FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M480.086 438.613C480.086 438.613 996.917 250.37 1361.6 364.135",
    stroke: "#C0E7FF",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M480.795 440.908C480.795 440.908 993.41 254.769 1361.6 369.332",
    stroke: "#C0E7FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M481.521 443.203C481.521 443.203 989.92 259.168 1361.62 374.529",
    stroke: "#C0E7FF",
    strokeWidth: 1.12,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M482.23 445.498C482.23 445.498 986.413 263.566 1361.62 379.725",
    stroke: "#C0E7FF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M482.939 447.793C482.939 447.793 982.906 267.966 1361.6 384.923",
    stroke: "#C0E7FF",
    strokeWidth: 1.38,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M483.646 450.087C483.646 450.087 979.397 272.364 1361.6 390.119",
    stroke: "#C0E7FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M484.375 452.382C484.375 452.382 975.891 276.77 1361.62 395.322",
    stroke: "#C0E7FF",
    strokeWidth: 1.62,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M485.084 454.677C485.084 454.677 972.384 281.169 1361.62 400.52",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M485.791 456.971C485.791 456.971 968.874 285.568 1361.6 405.716",
    stroke: "#C0E7FF",
    strokeWidth: 1.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M486.52 459.267C486.52 459.267 965.387 289.968 1361.62 410.914",
    stroke: "#C0E7FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M859.726 33.7129C859.726 33.7129 309.692 227.415 -30.6035 114.447",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M859.162 31.418C859.162 31.418 313.471 223.051 -30.2773 109.25",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M858.581 29.1162C858.581 29.1162 317.252 218.687 -29.9492 104.054",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M858.018 26.8145C858.018 26.8145 321.032 214.324 -29.6406 98.8568",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M857.437 24.5127C857.437 24.5127 324.795 209.953 -29.3125 93.6601",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M856.873 22.21C856.873 22.21 328.574 205.589 -28.9863 88.4624",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M856.291 19.9082C856.291 19.9082 332.354 201.225 -28.6777 83.2727",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M855.728 17.6064C855.728 17.6064 336.135 196.862 -28.3496 78.076",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M855.146 15.3115C855.146 15.3115 339.896 192.491 -28.041 72.8791",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M854.582 13.0098C854.582 13.0098 343.675 188.127 -27.7148 67.6823",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M854.002 10.708C854.002 10.708 347.456 183.764 -27.3867 62.4856",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M853.438 8.40625C853.438 8.40625 351.236 179.4 -27.0781 57.2889",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M852.857 6.10449C852.857 6.10449 354.999 175.029 -26.75 52.0921",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M852.293 3.80273C852.293 3.80273 358.778 170.666 -26.4238 46.8954",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M851.711 1.50781C851.711 1.50781 362.558 166.302 -26.1152 41.6984",
    stroke: "#C0E7FF",
    strokeOpacity: 0.5,
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_361_109839",
    x1: -46.3234,
    y1: 357.858,
    x2: 1440,
    y2: 357.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#E618AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A630C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4156E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_361_109839",
    x1: -47.4499,
    y1: 353.113,
    x2: 1439.27,
    y2: 353.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F817A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#DF1FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A035C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3C58E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076BFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_361_109839",
    x1: -48.5773,
    y1: 348.346,
    x2: 1438.53,
    y2: 348.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D726B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#993AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3659E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D67F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_361_109839",
    x1: -49.7225,
    y1: 343.573,
    x2: 1437.78,
    y2: 343.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E926AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D12CB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#933EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#315AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1463F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_361_109839",
    x1: -50.8483,
    y1: 338.779,
    x2: 1437.06,
    y2: 338.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C933B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8C43CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2A5BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B5FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_361_109839",
    x1: -51.9762,
    y1: 333.949,
    x2: 1436.31,
    y2: 333.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA36B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C23ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8546CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#255AEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215BEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_361_109839",
    x1: -53.1032,
    y1: 329.092,
    x2: 1435.58,
    y2: 329.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D33EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BB41BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#7F4AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2857EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_361_109839",
    x1: -54.2467,
    y1: 324.205,
    x2: 1434.84,
    y2: 324.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB46BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B347C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#784CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F53E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_361_109839",
    x1: -55.3748,
    y1: 319.248,
    x2: 1434.09,
    y2: 319.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C44EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#AD4EC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#724ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354FE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_361_109839",
    x1: -56.501,
    y1: 314.221,
    x2: 1433.37,
    y2: 314.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC55C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A553C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6B4ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C4BE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_361_109839",
    x1: -57.6287,
    y1: 309.102,
    x2: 1432.62,
    y2: 309.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B55DC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9E58C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#654DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4247DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_361_109839",
    x1: -58.7732,
    y1: 303.849,
    x2: 1431.89,
    y2: 303.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE65C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#975DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5F4AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4943DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_361_109839",
    x1: -59.8987,
    y1: 298.405,
    x2: 1431.15,
    y2: 298.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A66DCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9061CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#5743D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#503FD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_361_109839",
    x1: -61.0263,
    y1: 292.7,
    x2: 1430.4,
    y2: 292.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F75CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8963CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563BD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_361_109839",
    x1: -62.1526,
    y1: 286.655,
    x2: 1429.68,
    y2: 286.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#977DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8567D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D37D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_361_109839",
    x1: -63.2977,
    y1: 280.181,
    x2: 1428.93,
    y2: 280.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9084D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#846ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6637CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6434CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_361_109839",
    x1: -64.4248,
    y1: 273.212,
    x2: 1428.19,
    y2: 273.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#8176D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6F40CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A30C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_361_109839",
    x1: -65.5522,
    y1: 265.727,
    x2: 1427.46,
    y2: 265.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8194DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7D7FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7549CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#712CC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_361_109839",
    x1: -66.6773,
    y1: 258.454,
    x2: 1426.72,
    y2: 258.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A9CDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#7987D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7851CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7828C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_361_109839",
    x1: -67.8236,
    y1: 253.321,
    x2: 1425.97,
    y2: 253.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73A4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#748FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#795ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E24BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_361_109839",
    x1: -68.9492,
    y1: 248.809,
    x2: 1425.24,
    y2: 248.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BABE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6E96DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#7861CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8520BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_361_109839",
    x1: -70.0762,
    y1: 244.601,
    x2: 1424.5,
    y2: 244.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#699EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#776AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1CB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_361_109839",
    x1: -71.2025,
    y1: 240.506,
    x2: 1423.77,
    y2: 240.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CBBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#62A6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7372D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#8F1FB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9218B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_361_109839",
    x1: -72.3476,
    y1: 236.438,
    x2: 1423.03,
    y2: 236.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55C3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5CAFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#707BD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9029B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9914B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_361_109839",
    x1: -73.4744,
    y1: 232.357,
    x2: 1422.28,
    y2: 232.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ECBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#56B7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6C84D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9032BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F10AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_361_109839",
    x1: -74.6007,
    y1: 228.248,
    x2: 1421.56,
    y2: 228.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46D3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4FBFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#678CDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8F3BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60CAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_361_109839",
    x1: -75.7276,
    y1: 224.096,
    x2: 1420.81,
    y2: 224.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FDAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#49C6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6394DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8D43BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD08A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_361_109839",
    x1: -76.8739,
    y1: 219.909,
    x2: 1420.06,
    y2: 219.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37E2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#41CEF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5D9CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#8A4CC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B304A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_361_109839",
    x1: -78.0009,
    y1: 215.687,
    x2: 1419.34,
    y2: 215.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3BD6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#58A5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8755C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA00A1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg);
export default __webpack_public_path__ + "static/media/footerBG.69f83c92ecce53cffe15eb69688e6c72.svg";
export { ForwardRef as ReactComponent };